import type { IPageNavigator } from '@talbenmoshe/trip-os-react-model';

/** The part of the browser's `Location` this adapter needs, so tests can pass a stand-in. */
export interface IAssignableLocation {
  assign(address: string): void;
}

/** Loads an address as a whole page (the sign-in answer's `redirectTo`), leaving the single-page router. */
export class WindowPageNavigator implements IPageNavigator {
  constructor(private readonly location: IAssignableLocation) {}

  navigateTo(address: string): void {
    this.location.assign(address);
  }
}
